export default "__VITE_ASSET__CK65_s8g__"